export default __webpack_public_path__ + "f6fe0859035ef2098480cec1219eba3a.png";